import axios from 'axios';
// 通过局部引入方式引入 Element 的 Message 组件功能
import { Message, Loading } from 'element-ui';
// 引入 qs 用于进行请求参数处理
// import qs from 'qs';
// 引入 Vuex 的数据
import store from '@/store';
// 引入 router
// import router from '@/router';

// create 创建 axios 实例
const request = axios.create({
  timeout: 5000,
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/api',
  // headers:
});

let loadingInstance;
// 请求拦截器
request.interceptors.request.use((config) => {
  // 统一设置 Token 信息
  const { id } = store.state;
  if (id) {
    config.headers.schoolid = id;
  }
  if (store.state.data.openid) {
    config.headers.openid = store.state.data.openid;
  }
  if (store.state.data.nickname) {
    config.headers.nickname = encodeURIComponent(store.state.data.nickname);
  }
  // console.log('发起请求之前', config);
  // spinner: 'el-icon-loading'
  if (!config.hideLoading) {
    loadingInstance = Loading.service({ background: 'rgba(255, 255, 255, 0)' });
  }
  return config;
});

// 响应拦截器
request.interceptors.response.use((response) => {
  // 状态码 2xx 会执行这里
  // console.log('响应成功了：', response);
  if (response.data.code !== 200) {
    if (!response.config.hideLoading) {
      Message.error(response.data.msg);
    }
  }
  // 以服务的方式调用的 Loading 需要异步关闭
  if (!response.config.hideLoading) {
    loadingInstance.close();
  }
  return response;
}, (error) => {
  console.log(error.response);
  // 以服务的方式调用的 Loading 需要异步关闭
  if (!error.response.config.hideLoading) {
    loadingInstance.close();
  }
  if (error.response) {
    const { status } = error.response;
    let errorMessage = '';
    if (status === 400) {
      errorMessage = '请求参数错误';
    } else if (status === 403) {
      errorMessage = '没有权限，请联系管理员';
    } else if (status === 404) {
      errorMessage = '请求资源不存在';
    } else if (status >= 500) {
      errorMessage = '服务端错误，请联系管理员';
    }
    if (!error.response.config.hideLoading) {
      Message.error(errorMessage);
    }
  } else if (error.request) {
    // 请求发送成功，但是未收到响应
    // Message.error('请求超时，请重试');
  } else {
    // 意料之外的错误
    // eslint-disable-next-line no-lonely-if
    if (!error.response.config.hideLoading) {
      Message.error(error.msg);
    }
  }
  // 将本次请求的错误对象继续向后抛出，让接收响应的处理函数进行操作
  return Promise.reject(error);
});

export default request;
